import { memo, useMemo } from "react";
import { PieChart, Pie, Cell, Label } from "recharts";
import { DisaggregatedMetric } from "../../services/types";
import { useDashboardColor } from "../../context/DashboardColorContext";

interface MetricDonutChartProps {
    metric: DisaggregatedMetric | undefined;
}

const MetricDonutChart = memo(
    ({ metric }: MetricDonutChartProps) => {
        const color = useDashboardColor();
        const value = useMemo(() => {
            const version = metric?.versions?.[0];
            return version && typeof version.value === "number"
                ? Math.round(version.value * 100)
                : null;
        }, [metric]);

        const data = useMemo(() => {
            if (value === null) return [];
            return [
                { name: "Value", value: value },
                { name: "Remaining", value: 100 - value },
            ];
        }, [value]);

        if (value === null) {
            return (
                <div className="h-20 w-20 flex items-center justify-center text-xs text-slate-500">
                    No data
                </div>
            );
        }

        return (
            <div className="mx-2">
                <PieChart width={80} height={80}>
                    <Pie
                        data={data}
                        innerRadius={28}
                        outerRadius={40}
                        dataKey="value"
                        startAngle={90}
                        endAngle={-270}
                        stroke="none"
                    >
                        <Cell fill={color} />
                        <Cell fill="#D5D5D5" />
                        <Label
                            value={`${value}%`}
                            position="center"
                            style={{
                                fill: `${color}`,
                                fontSize: "28px",
                                fontWeight: 700,
                                fontFamily: "Barlow Condensed",
                            }}
                        />
                    </Pie>
                </PieChart>
            </div>
        );
    }
);

export default MetricDonutChart;
